import React from 'react';
import { HeartActive, HeartInactive } from '../../../foundations/icons/index';
import styles from './FavouriteIcon.module.scss';
export var FavouriteIcon = function (_a) {
    var _b = _a.filled, filled = _b === void 0 ? false : _b;
    return filled ? (React.createElement(HeartActive, { size: "medium", className: styles.filled })) : (React.createElement(HeartInactive, { size: "medium" }));
};
//# sourceMappingURL=FavouriteIcon.js.map